import { notificationMiddleWare } from "utils/NotificationMiddleWare";
import { apiBase } from "APIs/index";

export const AI_getLeaveList = apiBase.createListInstance({
  endpoint: "/leave/{id}/",
  method: "get",
  reducer: "leaveReducer",
  key: "id",
  reduxKey: "leaveData",
  action: "GET_LEAVE_LIST",
  listPath: "data.rows",
  onSuccess: (data) => data.leave,
});

export const AI_getAbsentees = apiBase.createListInstance({
  endpoint: "/absentees",
  method: "get",
  reducer: "leaveReducer",
  key: "id",
  reduxKey: "AbsenteeData",
  action: "GET_ABSENTEES",
  listPath: "data.rows",
  onSuccess: (data) => data.leave,
});

export const AI_LeaveRequestDetails = apiBase.createListInstance({
  endpoint: "/leave-request-details/",
  method: "get",
  reducer: "leaveReducer",
  key: "id",
  reduxKey: "leaveRequestDeatilsData",
  action: "GET_LEAVE_REQUEST_DETAILS",
  listPath: "data.rows",
  onSuccess: (data) => data.leave,
});

export const AI_deleteLeave = apiBase.createInstance({
  endpoint: "/leave",
  method: "delete",
  reducer: "leaveReducer",
  reduxKey: "deleteLeaveData",
  action: "DELETE_LEAVE",
  onSuccess: (data) => {
    AI_getLeaveList.deleteAction(data?.employee_id);
  },
  middleware: notificationMiddleWare,
});

export const AI_addLeave = apiBase.createInstance({
  endpoint: "/leave",
  method: "post",
  reducer: "leaveReducer",
  reduxKey: "addLeaveData",
  action: "ADD_LEAVE",
  middleware: notificationMiddleWare,
  onSuccess: (data) => {
    AI_getLeaveList.updateAction(data.leave);
  },
});

export const AI_updateLeave = apiBase.createInstance({
  endpoint: "/leave",
  method: "put",
  reducer: "leaveReducer",
  reduxKey: "updateLeaveData",
  action: "UPDATE_LEAVE",
  middleware: notificationMiddleWare,
  listPath: "data.rows",
  onSuccess: (data) => {
    AI_getLeaveList.updateAction([data.updated_leave]);
  },
});

export const AI_updateLeaveStatus = apiBase.createInstance({
  endpoint: "/update-leave-status/{id}",
  method: "put",
  reducer: "leaveReducer",
  reduxKey: "updateLeaveStatus",
  action: "UPDATE_LEAVE_STATUS",
  middleware: notificationMiddleWare,
  onSuccess: (data) => {
    AI_getLeaveList.updateAction([data.updated_leave]);
  },
});

export const AI_getPendingLeaveList = apiBase.createListInstance({
  endpoint: "/pending-leave-request",
  method: "get",
  reducer: "leaveReducer",
  key: "id",
  reduxKey: "pendingLeaveData",
  action: "GET_PENDING_LEAVE_LIST",
  listPath: "data.rows",
  onSuccess: (data) => data.leave,
});

export const AI_acknowledgeLeave = apiBase.createInstance({
  endpoint: "/acknowledge-leave/{id}",
  method: "put",
  reducer: "leaveReducer",
  reduxKey: "pendingLeaveDataUpdate",
  action: "UPDATE_LEAVE_ACKNOWLEDGE",
  middleware: notificationMiddleWare,
  onSuccess: (data) => {
    AI_getPendingLeaveList.updateAction([data.updated_leave]);
  },
});

export const AI_getLeaveDates = apiBase.createListInstance({
  endpoint: "/leave-dates/{id}",
  method: "get",
  reducer: "leaveReducer",
  key: "id",
  reduxKey: "leaveDates",
  action: "GET_LEAVE_DATES",
  onSuccess: (data) => {
    return data.leave_dates;
  },
});

export const AI_updateLeaveDates = apiBase.createInstance({
  endpoint: "/update-leave-date",
  method: "put",
  reducer: "leaveReducer",
  reduxKey: "updateLeaveDates",
  action: "UPDATE_LEAVE_DATES",
  middleware: notificationMiddleWare,
  listPath: "data.rows",
  onSuccess: (data) => {
    AI_getLeaveDates.updateAction(data.updated_leave_dates);
  },
});

export const AI_deleteLeaveDate = apiBase.createInstance({
  endpoint: "/delete-leave-date",
  method: "delete",
  reducer: "leaveReducer",
  reduxKey: "deleteLeaveDates",
  action: "DELETE_LEAVE_DATES",
  onSuccess: (data) => {
    AI_getLeaveDates.deleteAction(data?.leave_id);
  },
  middleware: notificationMiddleWare,
});
